import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Divider, Form, Input, Select, Spin, Tag } from "antd";
import {
  EntityStatus,
  ConfigActions,
  ConfigEntity,
  formItemLayout,
  tailItemLayout,
  ConfigJSON,
  GroupPurpose,
} from "../../../Constants/Constants";
import {
  jsonValidator,
  selectFilterFunction,
} from "../../../Constants/Utilities";
import { apiCallback } from "../../../ApiHandlers/Common";
import { getConfigFormTitle } from "../../../Helpers/ConfigHelpers";
import { onFormSubmit } from "../../../ApiHandlers/ConfigApiHandlers";
import { convertServiceSimpleList } from "../../../Helpers/ServiceHelpers";
import { convertGroupListToDropdown } from "../../../Helpers/GroupHelpers";
import { convertDeviceListToDropdown } from "../../../Helpers/DeviceHelpers";
import { convertServiceProviderListToDropdown } from "../../../Helpers/ServiceProviderHelpers";
import { DiscardWarning } from "../../Common/DiscardWarning";
import { message } from "antd";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

const getInitialValues = (record) => {
  const initialValues = {
    status: EntityStatus.ACTIVE,
    config: ConfigJSON,
  };
  if (record) {
    initialValues.name = record.name;
    initialValues.status = record.status;
    initialValues.providerId = record.providerId;
    initialValues.deviceId = record.deviceUuid;
    initialValues.groupId = record.groupId;
    initialValues.serviceId = record.serviceId;
    initialValues.config = JSON.stringify(record.config, null, 4);
  }
  return initialValues;
};
const DeviceConfigForm = (props) => {
  console.log("DeviceForm props", props);
  const {
    action,
    history,
    record,
    groupApi,
    deviceApi,
    onActionClick,
    serviceProviderApi,
    serviceApi,
  } = props;

  const title = useMemo(() => getConfigFormTitle(action), []);
  const [initialValues, setInitialValues] = useState(getInitialValues(record));

  // service info
  const [serviceDataLoading, setserviceDataLoading] = useState(false);
  const [serviceData, setserviceData] = useState([]);

  // provider info
  const [providerData, setproviderData] = useState([]);
  const [providerDataLoading, setproviderDataLoading] = useState(false);

  const [form] = Form.useForm();
  const [selected, setSelected] = useState({
    provider: initialValues.providerId,
    group: initialValues.groupId,
  });
  //group info
  const [groupData, setGroupData] = useState([]);
  const [groupDataLoading, setGroupDataLoading] = useState(false);

  //device info
  const [deviceData, setDeviceData] = useState([]);
  const [deviceDataLoading, setDeviceDataLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const isAddForm = props.action === ConfigActions.add;
  const isViewForm = props.action === ConfigActions.view;

  useEffect(() => {
    updateProviderList();
    updateServiceList();
    initialValues.providerId && updateGroupList(initialValues.providerId);
    initialValues.groupId && updateDeviceList(initialValues.groupId);
  }, []);

  useEffect(() => {
    const { providerId, groupId } = initialValues;
    providerId && updateGroupList(providerId);
    groupId && updateDeviceList(groupId);
  }, []);

  const updateServiceList = () => {
    console.log("fetchserviceList...");
    setserviceDataLoading(true);
    const errorCallback = (error) => {
      setserviceDataLoading(false);
      message.error("Error fetching service list");
      console.log("UpdateServiceList", error);
    };
    const successCallback = (data) => {
      console.log("fetchDeviceModelList data", data);
      const serviceData = convertServiceSimpleList(data);
      setserviceDataLoading(false);
      console.log("serviceData", serviceData);
      setserviceData(serviceData);
    };
    try {
      serviceApi.getService(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  const updateProviderList = () => {
    console.log("fetchProviderList...");
    setproviderDataLoading(true);
    const errorCallback = (error) => {
      setproviderDataLoading(false);
      message.error("Error fetching Provider list");
    };
    const successCallback = (data) => {
      console.log("fetchproviderList data", data);
      const providerData = convertServiceProviderListToDropdown(data);
      setproviderDataLoading(false);
      setproviderData(providerData);
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  const updateGroupList = (id) => {
    const providerId = id || selected.provider;
    if (!providerId) return;
    setGroupDataLoading(true);
    const errorCallback = (error) => {
      setGroupDataLoading(false);
      message.error("Error fetching Group list");
    };
    const successCallback = (data) => {
      const groupData = convertGroupListToDropdown(data);
      const entitlementGroupData = groupData.filter((item) => {
        return item.purpose === GroupPurpose.entitlement.value;
      });
      console.log("updateDataList data", entitlementGroupData);
      setGroupDataLoading(false);
      setGroupData(entitlementGroupData);
    };
    try {
      groupApi.getGroupsByProviderId(
        providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };
  const updateDeviceList = (id) => {
    const groupId = id || selected.group;
    if (!groupId) return;
    setDeviceDataLoading(true);
    const errorCallback = (error) => {
      setDeviceDataLoading(false);
      message.error("Error fetching Device list");
    };
    const successCallback = (data) => {
      const deviceData = convertDeviceListToDropdown(data);
      console.log("updateData data", deviceData);
      setDeviceDataLoading(false);
      setDeviceData(deviceData);
    };
    try {
      deviceApi.getDeviceByGroupId(
        groupId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  //On Change Func's
  const onProviderChange = (id) => {
    form.setFieldsValue({ groupId: null, deviceId: null });
    setSelected({ provider: id, group: null });
    id && updateGroupList(id);
  };

  const onGroupChange = (id) => {
    form.setFieldsValue({ deviceId: null });
    setSelected({ ...selected, group: id });
    id && updateDeviceList(id);
  };

  const onSubmit = (values) => {
    const model = deviceData.filter(
      (item) => item.deviceUuid === values.deviceId
    );
    values.deviceModelId = model[0]?.modelId;
    onFormSubmit({
      setInitialValues,
      props,
      setProcessing,
      entity: ConfigEntity.device,
    })(values);
  };

  const onBackClick = () => {
    const isChanged =
      action === ConfigActions.view ? false : checkForInputChanges();

    DiscardWarning({ isChanged, onActionClick })();
  };

  const checkForInputChanges = () => {
    const fieldsToCheck = [
      "name",
      "providerId",
      "groupId",
      "deviceId",
      "serviceId",
      "config",
      "status",
    ];
    const values = form.getFieldsValue();
    let isInputsChanged = false;
    fieldsToCheck.every((f) => {
      if (
        values.hasOwnProperty(f) &&
        values[f] !== initialValues[f] &&
        (!!values[f] || !!initialValues[f])
      ) {
        isInputsChanged = true;
        return false;
      }
      return true;
    });
    return isInputsChanged;
  };

  return (
    <div className="list-container">
      <div className="page-header-container">
        <BreadCrumbs
          headers={props.parentBread.concat(
            props.parentHeader,
            `${title} Device Configuration`
          )}
          onParentActionClick={onBackClick}
        />
      </div>
      <Divider className="divider" />
      <div className="form-data-container">
        <fieldset disabled={isViewForm}>
          <Form
            form={form}
            layout="horizontal"
            name="device-config-form"
            initialValues={initialValues}
            requiredMark={"optional"}
            onFinish={onSubmit}
            size={"middle"}
            {...formItemLayout}
          >
            <Spin spinning={processing} tip={"Processing, please wait..."}>
              <Form.Item
                name="name"
                label="Configuration Name"
                rules={[
                  { required: true, message: "Please fill in this field" },
                ]}
              >
                <Input
                  title="Name should be unique"
                  style={{ width: "90%", maxWidth: "300px" }}
                  disabled={!isAddForm}
                />
              </Form.Item>

              <Form.Item
                name="providerId"
                label="Service Provider:"
                rules={[
                  { required: true, message: "Please select Service Provider" },
                ]}
              >
                <Select
                  showSearch
                  allowClear
                  style={{ width: "90%", maxWidth: "350px" }}
                  loading={providerDataLoading}
                  disabled={providerDataLoading || !isAddForm}
                  filterOption={selectFilterFunction}
                  onChange={onProviderChange}
                  placeholder={
                    props.providerDataLoading
                      ? "Loading Service Provider list..."
                      : "Select Service Provider"
                  }
                >
                  {providerData?.map((item) => (
                    <Select.Option
                      key={item.providerId}
                      title={item.providerName}
                    >
                      {item.providerName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="groupId"
                label="Group:"
                rules={[{ required: true, message: "Please select Group" }]}
              >
                <Select
                  showSearch
                  allowClear
                  style={{ width: "90%", maxWidth: "350px" }}
                  loading={groupDataLoading}
                  disabled={
                    groupDataLoading || !selected.provider || !isAddForm
                  }
                  filterOption={selectFilterFunction}
                  onChange={onGroupChange}
                  placeholder={
                    !selected.provider
                      ? "Select Provider to view Groups"
                      : groupDataLoading
                      ? "Loading Group list..."
                      : "Select Group"
                  }
                >
                  {groupData?.map((item) => (
                    <Select.Option key={item.groupId} title={item.groupName}>
                      {item.groupName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="deviceId"
                label="Device:"
                rules={[{ required: true, message: "Please select Device" }]}
              >
                <Select
                  showSearch
                  allowClear
                  style={{ width: "90%", maxWidth: "350px" }}
                  loading={deviceDataLoading}
                  disabled={deviceDataLoading || !selected.group || !isAddForm}
                  filterOption={selectFilterFunction}
                  placeholder={
                    !selected.group
                      ? "Select Group to view Devices"
                      : deviceDataLoading
                      ? "Loading Device list..."
                      : "Select Device"
                  }
                >
                  {deviceData?.map((item) => (
                    <Select.Option key={item.deviceUuid} title={item.deviceId}>
                      {item.deviceId}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="serviceId"
                label="Service:"
                rules={[{ required: true, message: "Please select Service" }]}
              >
                <Select
                  showSearch
                  allowClear
                  style={{ width: "90%", maxWidth: "350px" }}
                  loading={props.serviceDataLoading}
                  disabled={props.serviceDataLoading || !isAddForm}
                  filterOption={selectFilterFunction}
                  placeholder={
                    props.serviceDataLoading
                      ? "Loading Service list..."
                      : "Select Service"
                  }
                >
                  {serviceData?.map((item) => (
                    <Select.Option
                      key={item.serviceId}
                      title={item.serviceName}
                    >
                      {item.serviceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="config"
                label="Configuration"
                validateTrigger={["onBlur"]}
                rules={[{ required: true, validator: jsonValidator() }]}
              >
                <Input.TextArea
                  title="Configuration must be JSON object"
                  autoSize={{ minRows: 4, maxRows: 8 }}
                  style={{ width: "90%", maxWidth: "500px" }}
                />
              </Form.Item>

              <Form.Item
                name="status"
                label="Status"
                rules={[{ required: true }]}
              >
                <Tag
                  color={
                    initialValues.status === EntityStatus.ACTIVE
                      ? "green"
                      : "red"
                  }
                >
                  {initialValues.status}
                </Tag>
              </Form.Item>

              {!isViewForm && (
                <Form.Item {...tailItemLayout}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                  >
                    {title}
                  </Button>
                  <Button
                    htmlType="button"
                    onClick={() => form.resetFields()}
                    className="cancel-button"
                  >
                    Cancel
                  </Button>
                </Form.Item>
              )}
            </Spin>
          </Form>
        </fieldset>
      </div>
    </div>
  );
};

DeviceConfigForm.propTypes = {
  action: PropTypes.string.isRequired,
  record: PropTypes.object,
  deviceData: PropTypes.array,
  onActionClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  groupRecord: PropTypes.object,
  parentBread: PropTypes.array,

  serviceApi: PropTypes.object,
  groupApi: PropTypes.object,
  deviceApi: PropTypes.object,
  configManagementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  groupApi: state.apis.groupApi,
  deviceApi: state.apis.deviceApi,
  serviceApi: state.apis.serviceApi,
  configManagementApi: state.apis.configManagementApi,
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedDeviceConfigForm = connect(mapStateToProps)(DeviceConfigForm);
export default withRouter(connectedDeviceConfigForm);
